/*
 * <slider-dots>: pairs page dots with a Dawn <slider-component>. Finds the
 * slider track ([id^="Slider-"]), the slides (.slider__slide) and the dot
 * buttons (.slider-counter__link--dots) inside this element, then wires
 * click-to-jump and active-state (+ aria-current) on scroll. Prev/next arrows
 * keep being handled by <slider-component>. Implemented as a custom element so
 * it re-binds when a section is re-rendered in the theme editor (an inline
 * <script> would not re-run on Section Rendering API reloads). Assumes one
 * slide per view (dots map 1:1 to slides), which is how it's used here.
 */
if (!customElements.get('slider-dots')) {
  class SliderDots extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[id^="Slider-"]');
      this.dots = Array.from(this.querySelectorAll('.slider-counter__link--dots'));
      this.slides = Array.from(this.querySelectorAll('.slider__slide'));
      if (!this.track || this.dots.length < 2 || this.slides.length < 2) return;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const step = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
          this.track.scrollTo({ left: i * step });
        });
      });

      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    }

    onScroll() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => {
        const step = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        const index = step ? Math.round(this.track.scrollLeft / step) : 0;
        this.setActive(Math.max(0, Math.min(this.dots.length - 1, index)));
      });
    }

    setActive(index) {
      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('slider-counter__link--active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('slider-dots', SliderDots);
}
